import React from "react";

function Social()
{
    return(
        <div className="home__social">
            <a href="" className="home__social-icon" target="_blank">
            <i class="uil uil-instagram-alt"></i>
            </a>
            <a href="https://github.com/Khushal-Pabri" className="home__social-icon" target="_blank">
                <i class="uil uil-github"></i>
            </a>
            <a href="https://in.linkedin.com/in/khushal-pabri-62b7b5238" className="home__social-icon" target="_blank">
                <i class="uil uil-linkedin"></i>
            </a>
        </div>
    );
}

export default Social;